import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('monsterleads')

export const lead = {
	computed : {
		id () {
			return this.$get('lead.id', 0)
		},
		fullName () {
			let name = this.$get('lead.first_name', '')
			if (this.$get('lead.last_name')) {
				name += name.length ? ` ${this.lead.last_name}` : this.lead.last_name
			}

			return name || ''
		},
		firstName () {
			return this.$get('lead.first_name') || ''
		},
		lastName () {
			return this.$get('lead.last_name') || ''
		},
		phone () {
			return this.$get('lead.phone') || ''
		},
		email () {
			return this.$get('lead.email') || ''
		},
		mailto () {
			return this.email ? `mailto:${this.email}` : ''
		},
		campaignId () {
			return this.$get('lead.campaign_id') || ''
		},
		campaignName () {
			return this.$get('lead.campaign_name') || ''
		},
		pageURL () {
			return this.$get('lead.page_url', '')
		},
		pageTitle () {
			return this.$get('lead.page_title', this.$get('lead.page_url'))
		},
		ip () {
			return this.$get('lead.ip') || ''
		},
		site () {
			let name = this.$get('lead.site_name') || ''
			if (this.$get('lead.site_domain')) {
				name = name
					? `${name} (${this.lead.site_domain})`
					: this.lead.site_domain
			}

			return name
		},
		tags () {
			return this.$get('lead.tags', []) || []
		},
		created () {
			return this.$moment(this.$get('lead.created') || Date.now())
				.format('MMM Do, YYYY @ h:mma')
		},
	},
	methods : {
		...mapActions([ 'goToCampaignFilteredPage', 'goToTagFilteredPage' ]),
		addToBulk () {
			this.$store.commit('monsterleads/addToBulk', this.$get('lead.id'))
		},
		removeFromBulk () {
			this.$store.commit('monsterleads/removeFromBulk', this.$get('lead.id'))
		},
		viewLead () {
			this.$modal.show(this.$get('lead.id') + '-show-lead-modal')
		},
		hideModal () {
			this.$modal.hide(this.$get('lead.id') + '-show-lead-modal')
		},
		maybeDeleteLead () {
			const confirmation = `Are you sure you want to delete this Lead, ${this.email || this.fullName || this.id} (#${this.id})`
			if (confirm(confirmation)) {
				this.deleteLead()
			}
		},
		deleteLead () {
			this.$store.dispatch('monsterleads/deleteLead', this.$get('lead.id'))
				.catch(e => {})
		},
		goCampaign () {
			this.goToCampaignFilteredPage(this.campaignId)
			this.hideModal()
		},
		goTag (tag) {
			this.goToTagFilteredPage(tag)
			this.hideModal()
		},
	},
}
